import { Box, Button, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { contractFormText } from '../../constants/contracts';
import Link from '../../inmarkit/Link';
import Checkbox from '../forms/Checkbox';
import FormSection from '../forms/FormSection';
import FormSubsection from '../forms/FormSubsection';
import BreakingFlex from '../shared/BreakingFlex';
import LciCampaignChipField from './LciCampaignChipField';

function ContractReportingSection() {
  const { setValue } = useFormContext();


  const lciMeasurement = useWatch({ name: 'lciMeasurement', defaultValue: false });
  const contractId     = useWatch({ name: 'contractId' });
  const isNewContract  = !contractId;

  useEffect(() => {
    if (!lciMeasurement) {
      setValue('contractLciCampaigns', [], { shouldValidate: true });
    }
  }, [lciMeasurement, setValue]);

  return (
    <FormSection title={contractFormText.sectionTitles.reporting}>
      <FormSubsection>
        <BreakingFlex breakpoint="sm">
          <Checkbox name="attributionEnabled" label="GeoTraffic Report" />
          <Checkbox name="lciMeasurement" label="LCI Report (+ $10K Internal Cost)" />

          <Box sx={{ width: 250, flexShrink: 0 }}>
            <LciCampaignChipField
              disabled={!lciMeasurement}
              rules={{
                validate: (rows: any[]) => {
                  if (!lciMeasurement) return true;
                  const hasActive =
                    Array.isArray(rows) &&
                    rows.some(
                      // eslint-disable-next-line no-underscore-dangle
                      (r) => r && r.lci_campaign_id != null && r._destroy !== '1' && r.active !== false
                    );
                  return hasActive || 'At least one ID required';
                },
              }}
            />
          </Box>

          <Checkbox name="placed" label="Placed Data" />
        </BreakingFlex>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 2,
            mt: 2,
            alignItems: 'center',
          }}
        >
          {isNewContract ? (
            <Typography variant="body1">
              {contractFormText.locationsUploadTip}
            </Typography>
          ) : (
            <>
              <Button onClick={() => {}}>
                Upload Locations
              </Button>
              <Typography variant="body1">
                (CSV format only,{' '}
                <Link target="_blank" href={contractFormText.locationsTemplateLink}>
                  See Template
                </Link>
                )
              </Typography>
            </>
          )}
        </Box>
      </FormSubsection>
    </FormSection>
  );
}

export default ContractReportingSection;
